import http, { AUTH_ROUTES } from "../../../services/api";

export const getDataServiceIDs = async () => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_DATA_SERVICES_IDS);
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch data service IDs");
  }
};

export const getDataServiceVariants = async (serviceID) => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_DATA_SERVICE_VARIANTS, {
      params: { serviceID },
    });
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTVServiceIDs = async () => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_TV_SERVICE_IDS);
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTVServiceVariants = async (serviceID) => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_TV_SERVICE_VARIANTS, {
      params: { serviceID },
    });
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getElectricityServiceIDs = async () => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_ELECTRICITY_SERVICE_IDS);
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const verifyMeterNumber = async (payload) => {
  try {
    const res = await http.post(AUTH_ROUTES.VERIFY_METER, payload);
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUserVtuTransactions = async (params = {}) => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_VTU_TRANSACTIONS, { params });
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const createVtuCustomerComplaint = async (payload) => {
  try {
    const res = await http.post(AUTH_ROUTES.CREATE_VTU_COMPLAINT, payload);
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const initiateVtuPaystackPayment = async (payload) => {
  try {
    const res = await http.post(AUTH_ROUTES.VTU_PAY_INITIATE, payload);
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const verifyVtuPaystackPayment = async (payload) => {
  try {
    const res = await http.post(AUTH_ROUTES.VTU_PAY_VERIFY, payload);
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getInsuranceVariants = async () => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_INSURANCE_VARIANTS, {
      params: { serviceID: "ui-insure" },
    });
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getInsuranceVehicleColors = async () => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_INSURANCE_COLORS);
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getInsuranceEngineCapacities = async () => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_INSURANCE_ENGINE_CAPACITY);
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getInsuranceStates = async () => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_INSURANCE_STATES);
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getInsuranceLGAs = async (stateCode) => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_INSURANCE_LGAS(stateCode));
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getInsuranceVehicleBrands = async () => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_INSURANCE_BRANDS);
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getInsuranceVehicleModels = async (makeCode) => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_INSURANCE_MODELS(makeCode));
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const verifyJambProfile = async (payload) => {
  try {
    const res = await http.post(AUTH_ROUTES.VERIFY_JAMB_PROFILE, payload);
    return res.data?.data ?? res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
